<template>
  <v-container fluid class="pt-2">
    <v-navigation-drawer
            class="blue-grey darken-4"
            dark
            persistent
            :mini-variant="miniVariant"
            :clipped="clipped"
            v-model="drawer"
            enable-resize-watcher
            fixed
            width="200"
            app
    >
      <v-list>
        <v-subheader>Integrations</v-subheader>
        <v-list-tile
                value="true"
                v-for="(item, i) in items"
                :key="i"
                style="cursor: pointer"
                :class="[currentintegration === item.title? 'blue-grey darken-3':'']"
        >
          <v-list-tile-action>
            <v-icon v-html="item.icon" class="grey--text text--lighten-3"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content >
            <v-list-tile-title @click="currentintegration=item.title" class="grey--text text--lighten-3">{{item.title}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-slide-y-transition mode="out-in">
      <v-layout column align-center>
        <order-status-list v-if="currentintegration==='order'" class="ma-0 pa-0"></order-status-list>
        <transaction-status-list v-if="currentintegration==='transaction'" class="ma-0 pa-0"></transaction-status-list>
        <estimate-status-list v-if="currentintegration==='estimate'" class="ma-0 pa-0"></estimate-status-list>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
<script scoped>
  import OrderStatusList from '../components/OrderStatusList';
  import TransactionStatusList from '../components/TransactionStatusList';
  import EstimateStatusList from '../components/EstimateStatusList';

  export default {
    name: 'Home',
    created() {

    },
    methods: {
    },
    data () {
      return {
        currentintegration: "order",
        clipped: true,
        drawer: true,
        fixed: false,
        items: [
          {
            icon: 'open_in_new',
            title: 'order'
          },
          {
            icon: 'open_in_new',
            title: 'transaction'
          },
          {
            icon: 'open_in_new',
            title: 'estimate'
          },
          {
          icon: 'open_in_new',
          title: 'item'
          },
          {
            icon: 'open_in_new',
            title: 'customer'
          },
          ],
        miniVariant: false,
        right: true,
        rightDrawer: false,
        title: 'Magic Gecko'
      }
    },
    components: {
      OrderStatusList,
      TransactionStatusList,
      EstimateStatusList
    }
  }
</script>